module.exports = __webpack_public_path__ + "img/zhengque.ff40aef4.png";